<template>
  <div class="ls-dropdown" :class="activeClass">
    <slot name="trigger"></slot>
    <slot name="list"></slot>
  </div>
</template>

<script>
  export default {
    props: ['opened', 'list', 'width'],
    data () {
      return {
        active: false
      }
    },
    mounted () {
      // watch não funcionou
      setInterval(this.setTriggerStyle, 100)

      this.$slots.trigger[0].elm.addEventListener('click', this.toggleDropdown)
      this.$slots.trigger[0].elm.addEventListener('blur', this.blurDropdown)

      this.setTriggerStyle()
      this.active = this.opened
    },
    methods: {
      toggleDropdown () {
        this.changeActive()
      },
      changeActive () {
        this.active = !this.active
      },
      inactivate (target) {
        if (target === undefined || target !== this.$el) this.active = false
      },
      blurDropdown (event) {
        var active = event.relatedTarget
        this.inactivate(event.target)
        if (this.$slots.list[0].elm.contains(active)) {
          active.click()
        }
      },
      setTriggerStyle () {
        if (this.hasElements()) {
          this.setStyle('block', this.width || 'auto')
        } else {
          var width = 'auto'
          if (this.list) width = '34px'

          this.setStyle('none', width)
        }
      },
      hasElements () {
        return this.$slots.list[0].elm.children.length !== 0
      },
      setStyle (display, width) {
        this.$slots.trigger[0].elm.style.display = display
        this.$slots.trigger[0].elm.parentNode.style.width = width
      }
    },
    computed: {
      activeClass () {
        if (this.active) return 'ls-active'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// Dropdown.vue?1361d0b0